import type { BizType, Industry } from './types';

export const BUSINESS_TYPES: BizType[] = [
  { id: 'sole_prop' },
  { id: 'partnership' },
  { id: 'corporation' },
  { id: 'nonprofit' },
  { id: 'cooperative' },
  { id: 'other' },
];

export const INDUSTRIES: Industry[] = [
  { id: 'construction', subIds: ['general_contracting', 'residential_building', 'trades', 'roofing', 'hvac', 'landscaping', 'other'] },
  { id: 'healthcare', subIds: ['home_care', 'clinics', 'dental', 'physio', 'mental_health', 'other'] },
  { id: 'retail', subIds: ['grocery', 'apparel', 'specialty', 'ecommerce', 'other'] },
  { id: 'restaurants', subIds: ['full_service', 'quick_service', 'cafes', 'food_trucks', 'catering', 'other'] },
  { id: 'professional', subIds: ['legal', 'accounting', 'consulting', 'marketing', 'design', 'other'] },
  { id: 'technology', subIds: ['saas', 'it_services', 'web_dev', 'hardware', 'other'] },
  { id: 'manufacturing', subIds: ['food_processing', 'wood_products', 'metal', 'textiles', 'other'] },
  { id: 'transportation', subIds: ['trucking', 'courier', 'warehousing', 'rideshare', 'other'] },
  { id: 'nonprofit_industry', subIds: ['charity', 'foundation', 'association', 'other'] },
  { id: 'other' },
];

export const TEAM_SIZE_IDS = ['solo', 'small', 'medium', 'large'] as const;
